import { useState, useCallback, useMemo, useEffect, useRef } from "react";
import { useOpenAiGlobal } from "../use-openai-global";
import { useWidgetState } from "../use-widget-state";

const LOGO_DATA_URI = "data:image/png;base64,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";
const CUBE_DATA_URI = "data:image/png;base64,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";
import type { DisplayMode } from "../types";
import "./all-ten.css";

type PuzzleData = {
  numbers: number[];
  puzzleNumber: number;
  date: string;
};

type AllTenWidgetState = {
  solved: Record<number, string>;
  solveOrder: number[];
};

type StreakStats = {
  played: number;
  streak: number;
  allTen: number;
  lastPlayedDate: string;
  lastCompletedDate: string;
};

function getStreakStats(): StreakStats {
  try {
    const raw = localStorage.getItem("allten_streak");
    if (raw) return JSON.parse(raw);
  } catch {}
  return { played: 0, streak: 0, allTen: 0, lastPlayedDate: "", lastCompletedDate: "" };
}

function saveStreakStats(stats: StreakStats) {
  try {
    localStorage.setItem("allten_streak", JSON.stringify(stats));
  } catch {}
}

function recordPlay(date: string) {
  const stats = getStreakStats();
  if (stats.lastPlayedDate === date) return;
  stats.played++;
  const yesterday = new Date(new Date(date).getTime() - 86400000).toISOString().slice(0, 10);
  if (stats.lastPlayedDate === yesterday) {
    stats.streak++;
  } else {
    stats.streak = 1;
  }
  stats.lastPlayedDate = date;
  saveStreakStats(stats);
}

function recordAllTen(date: string) {
  const stats = getStreakStats();
  if (stats.lastCompletedDate === date) return;
  stats.allTen++;
  stats.lastCompletedDate = date;
  saveStreakStats(stats);
}

type Token = {
  type: "number" | "operator";
  value: string;
  buttonIndex?: number;
  consumedIndices?: number[];
  sourceExpression?: string;
};

type FlyAnim = {
  target: number;
  expression: string;
  x: number;
  y: number;
  destX: number;
  destY: number;
  phase: "start" | "flying" | "done";
};

const OPERATORS = ["+", "\u2212", "\u00D7", "\u00F7"];
const PARENS = ["(", ")"];

const OPERATOR_KEY_MAP: Record<string, string> = {
  "+": "+",
  "-": "\u2212",
  "*": "\u00D7",
  "x": "\u00D7",
  "X": "\u00D7",
  "/": "\u00F7",
};

function tokenizeExpr(expr: string): string[] {
  const s = expr
    .replace(/\u2212/g, "-")
    .replace(/\u00D7/g, "*")
    .replace(/\u00F7/g, "/");
  const toks: string[] = [];
  let i = 0;
  while (i < s.length) {
    if (s[i] === " ") { i++; continue; }
    if ("+-*/()".includes(s[i])) { toks.push(s[i]); i++; continue; }
    if (/\d/.test(s[i])) {
      let num = "";
      while (i < s.length && /[\d.]/.test(s[i])) { num += s[i]; i++; }
      toks.push(num);
      continue;
    }
    return [];
  }
  return toks;
}

type ASTNode = { type: "num"; value: number } | { type: "op"; op: string; left: ASTNode; right: ASTNode };

function parseExpr(tokens: string[], pos: { i: number }): ASTNode | null {
  let left = parseTerm(tokens, pos);
  if (!left) return null;
  while (pos.i < tokens.length && (tokens[pos.i] === "+" || tokens[pos.i] === "-")) {
    const op = tokens[pos.i++];
    const right = parseTerm(tokens, pos);
    if (!right) return null;
    left = { type: "op", op, left, right };
  }
  return left;
}

function parseTerm(tokens: string[], pos: { i: number }): ASTNode | null {
  let left = parseFactor(tokens, pos);
  if (!left) return null;
  while (pos.i < tokens.length && (tokens[pos.i] === "*" || tokens[pos.i] === "/")) {
    const op = tokens[pos.i++];
    const right = parseFactor(tokens, pos);
    if (!right) return null;
    left = { type: "op", op, left, right };
  }
  return left;
}

function parseFactor(tokens: string[], pos: { i: number }): ASTNode | null {
  if (pos.i >= tokens.length) return null;
  if (tokens[pos.i] === "-") {
    pos.i++;
    const operand = parseFactor(tokens, pos);
    if (!operand) return null;
    return { type: "op", op: "*", left: { type: "num", value: -1 }, right: operand };
  }
  if (tokens[pos.i] === "(") {
    pos.i++;
    const node = parseExpr(tokens, pos);
    if (!node || pos.i >= tokens.length || tokens[pos.i] !== ")") return null;
    pos.i++;
    return node;
  }
  const raw = tokens[pos.i];
  if (!/^\d+(\.\d+)?$/.test(raw)) return null;
  const val = Number(raw);
  if (isNaN(val)) return null;
  pos.i++;
  return { type: "num", value: val };
}

function evalAST(node: ASTNode): number | null {
  if (node.type === "num") return node.value;
  const l = evalAST(node.left);
  const r = evalAST(node.right);
  if (l === null || r === null) return null;
  switch (node.op) {
    case "+": return l + r;
    case "-": return l - r;
    case "*": return l * r;
    case "/": return r === 0 ? null : l / r;
    default: return null;
  }
}

function evaluateLocally(expr: string): number | null {
  const tokens = tokenizeExpr(expr);
  if (tokens.length === 0) return null;
  const pos = { i: 0 };
  const ast = parseExpr(tokens, pos);
  if (!ast || pos.i < tokens.length) return null;
  const result = evalAST(ast);
  return result !== null && isFinite(result) ? result : null;
}

function formatResult(n: number): string {
  if (Number.isInteger(n)) return String(n);
  const frac = n.toFixed(6).replace(/0+$/, "").replace(/\.$/, "");
  return frac;
}

function buildFullExpression(tokens: Token[]): string {
  const hasIntermediateResults = tokens.some((t) => t.sourceExpression);
  if (!hasIntermediateResults) {
    return tokens.map((t) => t.value).join(" ");
  }
  const parts: string[] = [];
  for (const t of tokens) {
    if (t.sourceExpression) {
      const needsParens = tokens.length > 1;
      parts.push(needsParens ? `( ${t.sourceExpression} )` : t.sourceExpression);
    } else {
      parts.push(t.value);
    }
  }
  return parts.join(" ");
}

function getFunMessage(count: number): string {
  if (count === 0) return "Let's go!";
  if (count <= 3) return "Nice start!";
  if (count <= 6) return "Keep it up!";
  if (count <= 9) return "Almost there!";
  return "You got All Ten!";
}

const LAUNCH_DATE = new Date(Date.parse("19 Sep 2022 00:00:00 PST"));
const DAY_IN_MS = 3600 * 24 * 1000;
const PROBLEMS_BY_DAY = [
  "1126","1225","1255","4479","4445","2557","4489","2268","1299","2277",
  "4679","2367","1247","3467","3346","3578","2667","2399","2269","1278",
  "1135","3679","4689","3447","1145","1227","2777","1279","1357","1249",
  "3455","2778","2578","1789","2377","3399","1337","4568","2238","4458",
  "1344","1335","3566","3799","1458","2299","2458","2333","1229","1138",
  "2227","1445","1348","3368","3478","1446","4468","1257","2344","3559",
  "1379","3479","3379","3389","1116","2256","2588","2288","1267","1358",
  "1349","1146","2688","2677","1457","2248","3357","1459","3466","2456",
  "1779","2356","3335","3569","2258","3359","2666","1269","2788","2566",
  "4466","1237","3446","3489","3469","3789","2559","2488","1488","2668",
  "2467","1338","2466","3358","2289","2388","3579","2556","1226","1557",
  "1799","2469","2267","1139","3445","2999","2336","1688","5568","1266",
  "3668","1236","2378","2468","3699","2479","2234","1277","1368","2278",
  "2339","1235","3458","1136","2569","3388","4467","2499","4448","1228",
  "2459","3468","2577","1668","2669","2589","1579","1469","1468","1466",
  "2247","2359","1133","4669","3567","2455","2337","1256","2335","5689",
  "2266","1288","1156","1245","3345","3488","2366","2349","1566","2244",
  "3448","3366","2899","2699","2678","5556","2446","1233","1369","1455",
  "2233","5567","1356","3556","1223","1124","1244","5578","4446","3348",
  "3369","2347","3349","1123","3456","2889","2338","4668","2237","3689",
  "1114","1137","1568","1238","4488","1222","1333","2558","3333","2389",
  "1248","4478","1144","2259","1345","2478","1115","1346","3557","2357",
  "2235","1259","2255","1355","2249","1577","2369","3555","1246","2568",
  "4688","4578","2489","5667","1567","1268","3339","1479","2449","3344",
  "4567","1448","1234","1336","2224","2555","3367","2448","2358","2799",
  "2334","2379","1359","1367","2229","1366","3558","2346","2345","3355",
  "3449","2368","2236","1339","2457","3337","1239","1678","4566","2567",
  "2245","1134","1467","5677","4456","3338","4588","3336","2579","2789",
  "2599","2447","2689","2279","2223","1289","2444","3677","4556","2679",
  "1224","5679","1125","2239","3589","3678","2226","1258","3334","1456",
  "2888","2225","2228","2477","2246","2779","3356","3378","2355","2445",
  "2348","4469","4457",
];

function getPuzzleForDate(date: Date): { numbers: number[]; dateLabel: string } {
  const daysSinceLaunch = Math.floor((Number(date) - Number(LAUNCH_DATE)) / DAY_IN_MS);
  const problemStr = PROBLEMS_BY_DAY[daysSinceLaunch % PROBLEMS_BY_DAY.length] || "1234";
  const numbers = problemStr.split("").map(Number);
  const dateLabel = date.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
  return { numbers, dateLabel };
}

function solveAllTen(digits: number[]): Record<number, string> {
  const ops = ["+", "\u2212", "\u00D7", "\u00F7"];
  const results: Record<number, string> = {};

  function permutations<T>(arr: T[]): T[][] {
    if (arr.length <= 1) return [arr];
    const out: T[][] = [];
    for (let i = 0; i < arr.length; i++) {
      const rest = [...arr.slice(0, i), ...arr.slice(i + 1)];
      for (const perm of permutations(rest)) out.push([arr[i], ...perm]);
    }
    return out;
  }

  function partitions(indices: number[]): [number[], number[]][] {
    const out: [number[], number[]][] = [];
    const n = indices.length;
    for (let mask = 1; mask < (1 << n) - 1; mask++) {
      const a: number[] = [], b: number[] = [];
      for (let i = 0; i < n; i++) {
        if (mask & (1 << i)) a.push(indices[i]); else b.push(indices[i]);
      }
      if (a.length > 0 && b.length > 0) out.push([a, b]);
    }
    return out;
  }

  type Expr = { val: number; str: string };

  function generate(nums: Expr[]): Expr[] {
    if (nums.length === 1) return nums;
    const out: Expr[] = [];
    const indices = nums.map((_, i) => i);
    for (const [aIdx, bIdx] of partitions(indices)) {
      const aNums = aIdx.map(i => nums[i]);
      const bNums = bIdx.map(i => nums[i]);
      for (const a of generate(aNums)) {
        for (const b of generate(bNums)) {
          for (const op of ops) {
            let val: number | null = null;
            let expr = "";
            const aStr = aNums.length > 1 ? `(${a.str})` : a.str;
            const bStr = bNums.length > 1 ? `(${b.str})` : b.str;
            switch (op) {
              case "+": val = a.val + b.val; expr = `${aStr} + ${bStr}`; break;
              case "\u2212": val = a.val - b.val; expr = `${aStr} \u2212 ${bStr}`; break;
              case "\u00D7": val = a.val * b.val; expr = `${aStr} \u00D7 ${bStr}`; break;
              case "\u00F7":
                if (b.val !== 0) { val = a.val / b.val; expr = `${aStr} \u00F7 ${bStr}`; }
                break;
            }
            if (val !== null && isFinite(val)) out.push({ val, str: expr });
          }
        }
      }
    }
    return out;
  }

  function check(e: Expr) {
    const v = e.val;
    if (Math.abs(v - Math.round(v)) < 1e-9 && v >= 1 && v <= 10 && !results[Math.round(v)]) {
      results[Math.round(v)] = e.str;
    }
  }

  for (const perm of permutations([0, 1, 2, 3])) {
    const d = perm.map(i => digits[i]);
    for (const e of generate(d.map(v => ({ val: v, str: String(v) })))) check(e);
    if (Object.keys(results).length === 10) return results;
  }

  for (const perm of permutations([0, 1, 2, 3])) {
    const d = perm.map(i => digits[i]);
    for (let i = 0; i < 3; i++) {
      for (let j = i + 1; j < 4; j++) {
        const concat = d[i] * 10 + d[j];
        const rest = d.filter((_, k) => k !== i && k !== j);
        for (const e of generate([
          { val: concat, str: String(concat) },
          { val: rest[0], str: String(rest[0]) },
          { val: rest[1], str: String(rest[1]) },
        ])) check(e);
      }
    }
    if (Object.keys(results).length === 10) return results;
  }

  return results;
}

export default function AllTen() {
  const toolOutput = useOpenAiGlobal("toolOutput") as Partial<PuzzleData> | null;
  const displayMode = useOpenAiGlobal("displayMode") as DisplayMode | null;
  const maxHeight = useOpenAiGlobal("maxHeight") as number | null;
  const safeAreaRaw = useOpenAiGlobal("safeArea") as
    | { insets?: { top?: number; bottom?: number; left?: number; right?: number } }
    | { top?: number; bottom?: number; left?: number; right?: number }
    | null;
  const safeAreaInsets = useMemo(() => {
    // In fullscreen mode the widget covers the entire viewport on mobile,
    // so we need to clear the iPhone notch / Dynamic Island even when
    // ChatGPT does not deliver a non-zero safeArea global. env(safe-area-inset-*)
    // is always 0 inside iframes, so we rely on this hardcoded floor.
    const isFs = displayMode === "fullscreen";
    const fallbackTop = isFs ? 60 : 0;
    const fallbackBottom = isFs ? 24 : 0;
    if (!safeAreaRaw) {
      return { top: fallbackTop, bottom: fallbackBottom, left: 0, right: 0 };
    }
    const insets = (safeAreaRaw as any).insets ?? safeAreaRaw;
    return {
      top: Math.max(Number(insets?.top) || 0, fallbackTop),
      bottom: Math.max(Number(insets?.bottom) || 0, fallbackBottom),
      left: Number(insets?.left) || 0,
      right: Number(insets?.right) || 0,
    };
  }, [safeAreaRaw, displayMode]);
  const containerRef = useRef<HTMLDivElement>(null);
  const displayRef = useRef<HTMLDivElement>(null);
  const rowRefs = useRef<Map<number, HTMLDivElement>>(new Map());

  const puzzle = useMemo<PuzzleData>(
    () => {
      if (toolOutput && Array.isArray(toolOutput.numbers) && toolOutput.numbers.length === 4) {
        return toolOutput as PuzzleData;
      }
      return {
        numbers: [1, 2, 3, 4],
        puzzleNumber: 0,
        date: new Date().toISOString().slice(0, 10),
      };
    },
    [toolOutput]
  );

  const [widgetState, setWidgetState] = useWidgetState<AllTenWidgetState>({
    solved: {},
    solveOrder: [],
  });

  const solved = widgetState?.solved ?? {};
  const solveOrder = widgetState?.solveOrder ?? [];
  const solvedCount = Object.keys(solved).length;
  const [showModal, setShowModal] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const [showStats, setShowStats] = useState(false);
  const [streakStats, setStreakStats] = useState<StreakStats>(getStreakStats);

  const yesterdayPuzzle = useMemo(() => {
    const yesterday = new Date(Date.now() - DAY_IN_MS);
    return getPuzzleForDate(yesterday);
  }, []);

  const yesterdaySolutions = useMemo(() => {
    if (!showStats) return {};
    return solveAllTen(yesterdayPuzzle.numbers);
  }, [showStats, yesterdayPuzzle.numbers]);

  // Note: ChatGPT's widget host controls iframe sizing via the
  // `maxHeight` global (consumed below in the .at inline style).
  // There is no `notifyIntrinsicHeight` in the public OpenAiGlobals
  // API (see src/types.ts), so previous attempts to "tell ChatGPT
  // our height" were silent no-ops.

  const [tokens, setTokens] = useState<Token[]>([]);
  const [usedButtons, setUsedButtons] = useState<Set<number>>(new Set());
  const [message, setMessage] = useState<{
    text: string;
    type: "error";
  } | null>(null);
  const [isValidating, setIsValidating] = useState(false);
  const [flyAnim, setFlyAnim] = useState<FlyAnim | null>(null);

  const focusDisplay = useCallback(() => {
    requestAnimationFrame(() => displayRef.current?.focus());
  }, []);

  const expressionString = useMemo(
    () => tokens.map((t) => t.value).join(" "),
    [tokens]
  );

  const handleNumberClick = useCallback(
    (num: number, buttonIndex: number) => {
      if (usedButtons.has(buttonIndex)) return;
      setTokens((prev) => {
        const last = prev.length > 0 ? prev[prev.length - 1] : null;
        if (last && last.type === "number" && (last.buttonIndex !== undefined || last.consumedIndices)) {
          const prevIndices = last.consumedIndices
            ? last.consumedIndices
            : [last.buttonIndex!];
          return [...prev.slice(0, -1), {
            type: "number" as const,
            value: last.value + String(num),
            consumedIndices: [...prevIndices, buttonIndex],
          }];
        }
        return [...prev, { type: "number" as const, value: String(num), buttonIndex }];
      });
      setUsedButtons((prev) => new Set(prev).add(buttonIndex));
      setMessage(null);
    },
    [usedButtons]
  );

  const handleOperatorClick = useCallback(
    (op: string) => {
      setTokens((prev) => [...prev, { type: "operator", value: op }]);
      setMessage(null);
    },
    []
  );

  const handleParenClick = useCallback(
    (p: string) => {
      setTokens((prev) => [...prev, { type: "operator", value: p }]);
      setMessage(null);
    },
    []
  );

  const handleBackspace = useCallback(() => {
    if (tokens.length === 0) return;
    const last = tokens[tokens.length - 1];
    if (last.type === "number") {
      if (last.consumedIndices && last.consumedIndices.length > 1) {
        const lastIdx = last.consumedIndices[last.consumedIndices.length - 1];
        setUsedButtons((prev) => {
          const next = new Set(prev);
          next.delete(lastIdx);
          return next;
        });
        const remainingIndices = last.consumedIndices.slice(0, -1);
        const remainingValue = last.value.slice(0, -1);
        if (remainingIndices.length === 1) {
          setTokens((prev) => [...prev.slice(0, -1), {
            type: "number" as const,
            value: remainingValue,
            buttonIndex: remainingIndices[0],
          }]);
        } else {
          setTokens((prev) => [...prev.slice(0, -1), {
            type: "number" as const,
            value: remainingValue,
            consumedIndices: remainingIndices,
          }]);
        }
      } else {
        const indicesToRelease: number[] = [];
        if (last.buttonIndex !== undefined) indicesToRelease.push(last.buttonIndex);
        if (last.consumedIndices) indicesToRelease.push(...last.consumedIndices);
        if (indicesToRelease.length > 0) {
          setUsedButtons((prev) => {
            const next = new Set(prev);
            for (const idx of indicesToRelease) next.delete(idx);
            return next;
          });
        }
        setTokens((prev) => prev.slice(0, -1));
      }
    } else {
      setTokens((prev) => prev.slice(0, -1));
    }
    setMessage(null);
  }, [tokens]);

  const handleUndo = useCallback(() => {
    setUsedButtons(new Set());
    setTokens([]);
    setMessage(null);
  }, []);

  const allIndicesInExpression = useMemo(() => {
    const indices = new Set<number>();
    for (const t of tokens) {
      if (t.buttonIndex !== undefined) indices.add(t.buttonIndex);
      if (t.consumedIndices) for (const idx of t.consumedIndices) indices.add(idx);
    }
    return indices;
  }, [tokens]);

  const allNumbersUsed =
    allIndicesInExpression.size >= puzzle.numbers.length &&
    puzzle.numbers.every((_, i) => allIndicesInExpression.has(i));

  const finalizeSolve = useCallback((target: number, expression: string) => {
    const prevSolved = widgetState?.solved ?? {};
    const prevOrder = widgetState?.solveOrder ?? [];
    const newSolved = { ...prevSolved, [target]: expression };
    const newOrder = [...prevOrder, target];
    setWidgetState((prev) => ({ ...prev, solved: newSolved, solveOrder: newOrder }));
    setUsedButtons(new Set());

    recordPlay(puzzle.date);

    if (Object.keys(newSolved).length === 10) {
      recordAllTen(puzzle.date);
      setStreakStats(getStreakStats());
      setTimeout(() => { setShowHelp(false); setShowModal(true); }, 400);
    }
  }, [widgetState, setWidgetState, puzzle.date]);

  const triggerSolveAnimation = useCallback((target: number, expression: string) => {
    const displayEl = displayRef.current;
    const rowEl = rowRefs.current.get(target);
    if (!displayEl || !rowEl) {
      finalizeSolve(target, expression);
      setTokens([]);
      return;
    }

    const displayRect = displayEl.getBoundingClientRect();
    const rowRect = rowEl.getBoundingClientRect();

    setFlyAnim({
      target,
      expression,
      x: displayRect.left + displayRect.width / 2 - 20,
      y: displayRect.top + displayRect.height / 2 - 20,
      destX: rowRect.left + 14,
      destY: rowRect.top + rowRect.height / 2 - 20,
      phase: "start",
    });
    setTokens([]);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setFlyAnim((prev) => prev ? { ...prev, phase: "flying" } : null);
      });
    });

    setTimeout(() => {
      setFlyAnim(null);
      finalizeSolve(target, expression);
      focusDisplay();
    }, 700);
  }, [finalizeSolve, focusDisplay]);

  const handleEquals = useCallback(async () => {
    if (!expressionString.trim() || isValidating || flyAnim) return;

    if (!allNumbersUsed) {
      const result = evaluateLocally(expressionString);
      if (result === null) {
        setMessage({ text: "Can't evaluate that expression.", type: "error" });
        return;
      }
      const currentIndices: number[] = [];
      for (const t of tokens) {
        if (t.buttonIndex !== undefined) currentIndices.push(t.buttonIndex);
        if (t.consumedIndices) currentIndices.push(...t.consumedIndices);
      }
      const sourceExpr = buildFullExpression(tokens);
      setTokens([
        { type: "number", value: formatResult(result), consumedIndices: currentIndices, sourceExpression: sourceExpr },
      ]);
      setMessage(null);
      return;
    }

    setIsValidating(true);
    setMessage(null);

    try {
      const exprForValidation = expressionString
        .replace(/\u2212/g, "-")
        .replace(/\u00D7/g, "*")
        .replace(/\u00F7/g, "/");

      let target: number | null = null;
      let valid = false;
      let errorMsg = "";

      const result = evaluateLocally(exprForValidation);
      if (result === null) {
        setMessage({ text: "Can't evaluate that expression.", type: "error" });
        setIsValidating(false);
        return;
      }
      const roundedResult = Math.round(result);
      const EPSILON = 1e-9;
      if (roundedResult < 1 || roundedResult > 10 || Math.abs(result - roundedResult) > EPSILON) {
        const resultStr = Number.isInteger(result) ? String(result) : result.toFixed(4);
        errorMsg = `That equals ${resultStr}, which isn't a whole number from 1 to 10.`;
      } else {
        valid = true;
        target = roundedResult;
      }

      if (valid && target !== null) {
        if (solved[target]) {
          setMessage({ text: `That equals ${target}, but you already solved it!`, type: "error" });
        } else {
          const fullExpression = buildFullExpression(tokens);
          triggerSolveAnimation(target, fullExpression);
        }
      } else {
        setMessage({ text: errorMsg, type: "error" });
      }
    } catch (err) {
      setMessage({
        text: err instanceof Error ? err.message : "Something went wrong.",
        type: "error",
      });
    } finally {
      setIsValidating(false);
    }
  }, [expressionString, tokens, allNumbersUsed, isValidating, flyAnim, solved, puzzle.numbers, widgetState, setWidgetState, triggerSolveAnimation]);

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      const key = e.key;

      if (key === "Enter" || key === "=") {
        e.preventDefault();
        handleEquals();
        return;
      }

      if (key === "Backspace") {
        e.preventDefault();
        handleBackspace();
        return;
      }

      if (key === "Escape") {
        e.preventDefault();
        handleUndo();
        return;
      }

      if (key === "(" || key === ")") {
        e.preventDefault();
        handleParenClick(key);
        return;
      }

      if (OPERATOR_KEY_MAP[key]) {
        e.preventDefault();
        handleOperatorClick(OPERATOR_KEY_MAP[key]);
        return;
      }

      if (/^\d$/.test(key)) {
        e.preventDefault();
        const digit = Number(key);
        for (let i = 0; i < puzzle.numbers.length; i++) {
          if (!usedButtons.has(i) && puzzle.numbers[i] === digit) {
            handleNumberClick(digit, i);
            return;
          }
        }
      }
    },
    [handleEquals, handleBackspace, handleUndo, handleParenClick, handleOperatorClick, handleNumberClick, puzzle.numbers, usedButtons]
  );

  const preventFocusLoss = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
  }, []);

  const [localFullscreen, setLocalFullscreen] = useState(typeof window !== "undefined" && window.location.search.includes("fs=1"));
  const goFullscreen = useCallback(() => {
    if (window.openai?.requestDisplayMode) {
      window.openai.requestDisplayMode({ mode: "fullscreen" });
    } else {
      setLocalFullscreen(true);
    }
  }, []);

  const isFullscreen = displayMode === "fullscreen" || localFullscreen;

  useEffect(() => {
    if (isFullscreen) {
      setTimeout(() => displayRef.current?.focus(), 100);
    }
  }, [isFullscreen]);



  if (!isFullscreen) {
    return (
      <div className="at-card" ref={containerRef}>
        <div className="at-card__header">
          <a
            className="at-card__brand-link"
            href="https://beastacademy.com?utm_source=chatgpt&utm_medium=allten"
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => { e.preventDefault(); window.openai?.openExternal?.({ href: "https://beastacademy.com?utm_source=chatgpt&utm_medium=allten" }); }}
          >
            <img src={LOGO_DATA_URI} alt="AoPS Beast Academy" className="at-card__logo" />
            <img src={CUBE_DATA_URI} alt="AoPS" className="at-card__logo-small" />
          </a>
          <span className="at-card__date">{puzzle.date}</span>
        </div>
        <div className="at-card__numbers">
          {puzzle.numbers.map((n, i) => (
            <div key={i} className="at-card__num">{n}</div>
          ))}
        </div>
        <div className="at-card__progress">
          <span className="at-card__score">{solvedCount}/10</span>
          <span className="at-card__msg">{getFunMessage(solvedCount)}</span>
        </div>
        <button className="at-card__play" onClick={goFullscreen}>
          Play
        </button>
      </div>
    );
  }

  const leftTargets = [1, 2, 3, 4, 5];
  const rightTargets = [6, 7, 8, 9, 10];

  const renderRow = (n: number) => {
    const isSolved = !!solved[n];
    return (
      <div
        key={n}
        ref={(el) => { if (el) rowRefs.current.set(n, el); }}
        className={`at__row ${isSolved ? "at__row--solved" : ""}`}
      >
        <span className="at__row-num">{n}</span>
        <span className="at__row-eq">{isSolved ? `= ${solved[n]}` : ""}</span>
      </div>
    );
  };

  return (
    <div
      className={isFullscreen ? "at at--fullscreen" : "at"}
      ref={containerRef}
      style={{
        maxHeight: maxHeight && maxHeight > 0 ? `${maxHeight}px` : "100%",
        minHeight: isFullscreen && maxHeight && maxHeight > 0 ? `${maxHeight}px` : undefined,
        paddingTop: `max(env(safe-area-inset-top), ${safeAreaInsets.top}px)`,
        paddingBottom: `max(env(safe-area-inset-bottom), ${safeAreaInsets.bottom}px)`,
        paddingLeft: `max(env(safe-area-inset-left), ${safeAreaInsets.left}px)`,
        paddingRight: `max(env(safe-area-inset-right), ${safeAreaInsets.right}px)`,
      }}
    >
      <div className="at__header">
        <div className="at__header-left">
          <button
            className="at__back"
            onMouseDown={preventFocusLoss}
            onClick={() => window.openai?.requestDisplayMode?.({ mode: "inline" })}
          >
            &larr;
          </button>
          <div className="at__score">{solvedCount}/10</div>
        </div>
        <a
          className="at__brand-link"
          href="https://beastacademy.com?utm_source=chatgpt&utm_medium=allten"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => { e.preventDefault(); window.openai?.openExternal?.({ href: "https://beastacademy.com?utm_source=chatgpt&utm_medium=allten" }); }}
        >
          <img src={LOGO_DATA_URI} alt="AoPS Beast Academy" className="at__logo" />
          <img src={CUBE_DATA_URI} alt="AoPS" className="at__logo-small" />
        </a>
        <div className="at__header-right">
          <button
            className="at__stats-btn"
            onMouseDown={preventFocusLoss}
            onClick={() => setShowStats(true)}
            aria-label="Stats"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <rect x="1" y="9" width="3" height="6" rx="0.5" fill="currentColor"/>
              <rect x="6" y="5" width="3" height="10" rx="0.5" fill="currentColor"/>
              <rect x="11" y="1" width="3" height="14" rx="0.5" fill="currentColor"/>
            </svg>
          </button>
          <button
            className="at__help-btn"
            onMouseDown={preventFocusLoss}
            onClick={() => setShowHelp(true)}
            aria-label="How to play"
          >
            ?
          </button>
        </div>
      </div>

      <div className="at__grid">
        <div className="at__col">
          {leftTargets.map(renderRow)}
        </div>
        <div className="at__col">
          {rightTargets.map(renderRow)}
        </div>
      </div>

      <div className="at__display-area">
        <div
          className="at__display"
          ref={displayRef}
          tabIndex={0}
          onKeyDown={handleKeyDown}
        >
          {expressionString || "\u00A0"}<span className="at__cursor" />
        </div>
      </div>

      {message && (
        <div className={`at__message at__message--${message.type}`}>
          {message.text}
        </div>
      )}

      <div className="at__numpad">
        {puzzle.numbers.map((n, i) => (
          <button
            key={i}
            className={`at__btn at__btn--number ${usedButtons.has(i) ? "at__btn--used" : ""}`}
            onMouseDown={preventFocusLoss}
            onClick={() => handleNumberClick(n, i)}
            disabled={usedButtons.has(i)}
          >
            {n}
          </button>
        ))}
      </div>

      <div className="at__oppad">
        {OPERATORS.map((op) => (
          <button
            key={op}
            className="at__btn at__btn--op"
            onMouseDown={preventFocusLoss}
            onClick={() => handleOperatorClick(op)}
          >
            {op}
          </button>
        ))}
        {PARENS.map((p) => (
          <button
            key={p}
            className="at__btn at__btn--op"
            onMouseDown={preventFocusLoss}
            onClick={() => handleParenClick(p)}
          >
            {p}
          </button>
        ))}
      </div>

      <div className="at__actions">
        <button
          className="at__btn at__btn--action"
          onMouseDown={preventFocusLoss}
          onClick={handleUndo}
          disabled={tokens.length === 0}
          aria-label="Undo"
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="#ffffff" aria-hidden="true">
            <path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z" />
          </svg>
        </button>
        <button
          className="at__btn at__btn--submit"
          onMouseDown={preventFocusLoss}
          onClick={handleEquals}
          disabled={!expressionString.trim() || isValidating}
        >
          =
        </button>
        <button
          className="at__btn at__btn--action"
          onMouseDown={preventFocusLoss}
          onClick={handleBackspace}
          disabled={tokens.length === 0}
        >
          &#9003;
        </button>
      </div>

      <div className="at__footer">
        <span className="at__fun-msg">{getFunMessage(solvedCount)}</span>
        <a
          className="at__link"
          href="https://beastacademy.com?utm_source=chatgpt&utm_medium=allten"
          onClick={(e) => {
            e.preventDefault();
            window.openai?.openExternal?.({ href: "https://beastacademy.com?utm_source=chatgpt&utm_medium=allten" });
          }}
        >
          Beast Academy
        </a>
      </div>

      {flyAnim && (
        <div
          className={`at__fly-circle ${flyAnim.phase === "flying" ? "at__fly-circle--fly" : ""}`}
          style={{
            left: flyAnim.phase === "flying" ? flyAnim.destX : flyAnim.x,
            top: flyAnim.phase === "flying" ? flyAnim.destY : flyAnim.y,
          }}
        >
          {flyAnim.target}
        </div>
      )}

      {showHelp && (
        <div className="at__modal-overlay" onClick={() => setShowHelp(false)}>
          <div className="at__modal at__modal--help" onClick={(e) => e.stopPropagation()}>
            <button className="at__modal-close" onClick={() => setShowHelp(false)}>&times;</button>
            <h2 className="at__modal-title">How to Play</h2>
            <p className="at__help-text">
              Use all four numbers once each to make 1 through 10 using the given operations.
            </p>
            <div className="at__help-section">
              <p className="at__help-text">
                For example, with 1, 2, 3, and 4, we can make:
              </p>
              <div className="at__help-examples">
                <div className="at__help-example"><span className="at__help-expr">(4{"\u2212"}3){"\u00F7"}(2{"\u2212"}1)</span><span className="at__help-result">1</span></div>
                <div className="at__help-example"><span className="at__help-expr">24{"\u00F7"}(3+1)</span><span className="at__help-result">6</span></div>
                <div className="at__help-example"><span className="at__help-expr">3{"\u2212"}4{"\u00F7"}2+1</span><span className="at__help-result">2</span></div>
                <div className="at__help-example"><span className="at__help-expr">4+3{"\u00D7"}(2{"\u2212"}1)</span><span className="at__help-result">7</span></div>
                <div className="at__help-example"><span className="at__help-expr">1+(4+2){"\u00F7"}3</span><span className="at__help-result">3</span></div>
                <div className="at__help-example"><span className="at__help-expr">32{"\u00F7"}4{"\u00D7"}1</span><span className="at__help-result">8</span></div>
                <div className="at__help-example"><span className="at__help-expr">14{"\u00F7"}2{"\u2212"}3</span><span className="at__help-result">4</span></div>
                <div className="at__help-example"><span className="at__help-expr">3{"\u00D7"}(4{"\u00F7"}2+1)</span><span className="at__help-result">9</span></div>
                <div className="at__help-example"><span className="at__help-expr">4+3{"\u00F7"}(1+2)</span><span className="at__help-result">5</span></div>
                <div className="at__help-example"><span className="at__help-expr">1+2+3+4</span><span className="at__help-result">10</span></div>
              </div>
            </div>
            <div className="at__help-section">
              <p className="at__help-text">
                You can type all four numbers in one expression and press <span className="at__help-eq-icon">=</span>.
              </p>
              <p className="at__help-text">
                Press <span className="at__help-eq-icon">=</span> anytime to calculate what you have. You can use the result to finish your equation.
              </p>
            </div>
            <div className="at__help-section">
              <p className="at__help-text">
                Fractions and negatives are allowed.
              </p>
              <p className="at__help-text">
                All four original numbers must be used.
              </p>
            </div>
            <p className="at__help-cta">Try to get all ten!</p>
          </div>
        </div>
      )}

      {showModal && (
        <div className="at__modal-overlay" onClick={() => setShowModal(false)}>
          <div className="at__modal" onClick={(e) => e.stopPropagation()}>
            <button className="at__modal-close" onClick={() => setShowModal(false)}>&times;</button>
            <h2 className="at__modal-title">You got all ten! 🎉</h2>
            <p className="at__modal-subtitle">
              Check out Beast Academy for more puzzles and our comprehensive math curriculum designed for advanced learners ages 6–13.
            </p>
            <a
              className="at__modal-cta"
              href="https://beastacademy.com?utm_source=chatgpt&utm_medium=allten"
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => {
                e.preventDefault();
                window.openai?.openExternal?.({ href: "https://beastacademy.com?utm_source=chatgpt&utm_medium=allten" });
              }}
            >
              Visit Beast Academy
            </a>
            <div className="at__modal-stats">
              <div className="at__modal-stat">
                <span className="at__modal-stat-label">PLAYED</span>
                <span className="at__modal-stat-value">{streakStats.played}</span>
                <span className="at__modal-stat-unit">days</span>
              </div>
              <div className="at__modal-stat">
                <span className="at__modal-stat-label">STREAK</span>
                <span className="at__modal-stat-value">{streakStats.streak}</span>
                <span className="at__modal-stat-unit">days</span>
              </div>
              <div className="at__modal-stat">
                <span className="at__modal-stat-label">ALL TEN</span>
                <span className="at__modal-stat-value">{streakStats.allTen}</span>
                <span className="at__modal-stat-unit">times</span>
              </div>
            </div>
            <div className="at__modal-order-label">SOLVE ORDER</div>
            <div className="at__modal-order">
              {solveOrder.map((n, i) => (
                <span key={i} className="at__modal-order-num">{n}</span>
              ))}
            </div>
          </div>
        </div>
      )}

      {showStats && (
        <div className="at__modal-overlay" onClick={() => setShowStats(false)}>
          <div className="at__modal at__modal--stats" onClick={(e) => e.stopPropagation()}>
            <button className="at__modal-close" onClick={() => setShowStats(false)}>&times;</button>
            <h2 className="at__modal-title">Stats</h2>
            <div className="at__modal-stats">
              <div className="at__modal-stat">
                <span className="at__modal-stat-label">PLAYED</span>
                <span className="at__modal-stat-value">{streakStats.played}</span>
                <span className="at__modal-stat-unit">days</span>
              </div>
              <div className="at__modal-stat">
                <span className="at__modal-stat-label">STREAK</span>
                <span className="at__modal-stat-value">{streakStats.streak}</span>
                <span className="at__modal-stat-unit">days</span>
              </div>
              <div className="at__modal-stat">
                <span className="at__modal-stat-label">ALL TEN</span>
                <span className="at__modal-stat-value">{streakStats.allTen}</span>
                <span className="at__modal-stat-unit">times</span>
              </div>
            </div>
            <div className="at__stats-yesterday">
              <div className="at__stats-yesterday-header">
                <div className="at__stats-yesterday-title">Yesterday's puzzle</div>
                <div className="at__stats-yesterday-numbers">{yesterdayPuzzle.numbers.join(" \u2003 ")}</div>
              </div>
              <div className="at__stats-solutions">
                {[1,2,3,4,5,6,7,8,9,10].map((target) => (
                  <div key={target} className="at__stats-solution-row">
                    <span className="at__stats-solution-expr">{yesterdaySolutions[target] || "\u2014"}</span>
                    <span className="at__stats-solution-target">{target}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
